/**
 * Route `/capture/animation` — rendu image par image de la vidéo d'une
 * animation (lot 7), pilotée par le worker vidéo (apps/video-worker, mode
 * animation). Publique et sans données : le worker y injecte le document de
 * la vidéo puis demande chaque image (`window.__jrCapture`, voir
 * `AnimationCapture`). Rien d'autre à l'écran : pas de navigation, pas de
 * marges, le canevas remplit la fenêtre.
 */

import { AnimationCapture } from '@/features/animations/animation-capture';
import { animationAssetUrl } from '@/lib/animations/voice';

export function CaptureAnimationPage() {
  return <AnimationCapture assetUrl={animationAssetUrl} />;
}
